import {
	ALL_ROLE_REQUEST_GET,
	ALL_ROLE_RESPONSE_GET_FAIL,
	ALL_ROLE_RESPONSE_GET_SUCCESS,
	DELETE_ROLE_RESPONSE_SUCCESS,
	RESET_ROLE_ADD,
	RESET_ROLE_DELETE,
	RESET_ROLE_EDIT,
	ROLE_DETAILS_REQUEST_GET,
	ROLE_DETAILS_RESPONSE_GET_FAIL,
	ROLE_DETAILS_RESPONSE_GET_SUCCESS,
	ROLE_PERMISSIONS_REQUEST_GET,
	ROLE_PERMISSIONS_RESPONSE_GET_SUCCESS,
	ROLE_REQUEST_ADD,
	ROLE_REQUEST_EDIT,
	ROLE_REQUEST_GET,
	ROLE_REQUEST_PUT,
	ROLE_RESPONSE_ADD_FAIL,
	ROLE_RESPONSE_ADD_SUCCESS,
	ROLE_RESPONSE_EDIT_FAIL,
	ROLE_RESPONSE_EDIT_SUCCESS,
	ROLE_RESPONSE_GET_FAIL,
	ROLE_RESPONSE_GET_SUCCESS,
	ROLE_RESPONSE_PUT_FAIL,
	ROLE_SELECTED,
	ROLE__PERMISSIONS_RESPONSE_GET_FAIL,
} from '../constants/roleConstants';

export const roleListReducer = (
	state = { roles: {}, allRoles: { loading: false, error: null, data: {} } },
	action
) => {
	switch (action.type) {
		case ROLE_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case ROLE_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				roles: action.payload,
			};
		case ROLE_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};

		case ALL_ROLE_REQUEST_GET:
			return {
				...state,
				allRoles: { ...state.allRoles, loading: true },
			};
		case ALL_ROLE_RESPONSE_GET_SUCCESS:
			return {
				...state,
				allRoles: {
					...state.allRoles,
					data: action.payload,
					loading: false,
				},
			};
		case ALL_ROLE_RESPONSE_GET_FAIL:
			return {
				...state,
				allRoles: {
					...state.allRoles,
					error: action.payload,
					loading: false,
				},
			};
		default:
			return state;
	}
};

export const roleDetailsReducer = (state = { roleDetails: {} }, action) => {
	switch (action.type) {
		case ROLE_DETAILS_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case ROLE_DETAILS_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				roleDetails: action.payload,
			};
		case ROLE_DETAILS_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export const rolePermissionsReducer = (
	state = { rolePermissions: {} },
	action
) => {
	switch (action.type) {
		case ROLE_PERMISSIONS_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case ROLE_PERMISSIONS_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				rolePermissions: action.payload,
			};
		case ROLE__PERMISSIONS_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export const roleReducer = (
	state = {
		roleSelected: {},
	},
	action
) => {
	switch (action.type) {
		case ROLE_SELECTED:
			return {
				...state,
				roleSelected: action.payload,
			};
		default:
			return state;
	}
};

export const roleDeleteReducer = (
	state = {
		status: null,
		deleteError: null,
		data: [],
		loading: false,
	},
	action
) => {
	switch (action.type) {
		case ROLE_REQUEST_PUT:
			return {
				...state,
				loading: true,
				deleteError: null,
			};
		case ROLE_RESPONSE_PUT_FAIL:
			return {
				...state,
				loading: false,
				deleteError: action.payload,
			};
		case DELETE_ROLE_RESPONSE_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case RESET_ROLE_DELETE:
			return {
				...state,
				loading: false,
				status: null,
				deleteError: null,
				data: [],
			};
		default:
			return state;
	}
};

export const roleAddReducer = (
	state = {
		status: null,
		addError: null,
		addData: [],
		loading: false,
	},
	action
) => {
	switch (action.type) {
		case ROLE_REQUEST_ADD:
			return { ...state, loading: true, addError: null };
		case ROLE_RESPONSE_ADD_FAIL:
			return {
				...state,
				loading: false,
				addError: action.payload,
			};
		case ROLE_RESPONSE_ADD_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case RESET_ROLE_ADD:
			return {
				...state,
				loading: false,
				status: null,
				addError: null,
				addData: [],
			};
		default:
			return state;
	}
};

export const roleEditReducer = (
	state = {
		statusData: null,
		editError: null,
		editData: [],
		loading: false,
	},
	action
) => {
	switch (action.type) {
		case ROLE_REQUEST_EDIT:
			return { ...state, loading: true, addError: null };
		case ROLE_RESPONSE_EDIT_FAIL:
			return {
				...state,
				loading: false,
				editError: action.payload,
			};
		case ROLE_RESPONSE_EDIT_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case RESET_ROLE_EDIT:
			return {
				...state,
				loading: false,
				statusData: null,
				editError: null,
				editData: [],
			};
		default:
			return state;
	}
};
